export const ACTIONS = {
    CHANGE_PASSWORD: "change_password",
    GET_PIN_CODE: "gsa/get_pin_code",
    GET_CITIES: "gsa/get_cities",
    GET_AREA: "gsa/get_area",
    GET_AGENTS: "gsa/get_agents",
    GET_AGENTS_BY_USERGROUP: "gsa/get_agents_by_usergroup",
    GET_PACKAGES: "gsa/get_packages",
    GET_PHLEBOS: "gsa/get_phlebos",
    GET_PARTNERS: "gsa/get_partners",
    GET_COUPONS: "gsa/get_coupons",
    CREATE_BOOKING: "gsa/create_booking",
    UPDATE_BOOKING: "gsa/update_booking",
    GET_BOOKING_LIST: "gsa/get_booking_list",
    CREATE_ADDITIONAL_BOOKING: "gsa/create_additional_booking",
    UPDATE_ADDITIONAL_BOOKING: "gsa/update_additional_booking",
    GET_LEAD_DETAILS: "gsa/get_lead_details",
    GET_LEAD_BY_ID: "gsa/get_lead_by_id",
    LEAD_DETAILS_RESET: "gsa/lead_details_reset",
    GET_LEADS: "gsa/get_leads",
    GET_BOOKING_BY_ID: "gsa/get_booking_by_id",
    CLICK_TO_CALL: "gsa/click_to_call",
    GET_POSTIVE_CALLS_COMMENTS: "gsa/get_postive_calls_commnets",
    ADD_POSTIVE_CALLS_COMMENT: "gsa/add_comments",
    SET_COMMENTS: "gsa/set_commnets",
    UPLOAD_FILE: "gsa/upload",
    SET_LOADING: "gsa/set_loading",
    SEARCH_CALL: "gsa/serach",
    BOOKING_RESET: "gsa/booking_reset",
    ADD_COMMENT: "positive_calls/add_comment",
    CREATE_CALL: "gsa/createcall",
    GET_LEAD_SOURCE: "gsa/getleadsource",
    GET_RECORDINGS: "gsa/get_recordings",
    GET_BOOKINGS_COMMENTS: "gsa/get_bookings_commnets",
    ADD_BOOKINGS_COMMENT: "gsa/add_bookings_comments",
    GET_WHATSAPP_COMMENTS: "gsa/get_whatsapp_comments",
    GET_WHATSAPP_COMMENTS_BY_LEAD: "gsa/get_whatsapp_comments_by_lead",
    SEND_WHATSAPP_COMMENTS: "gsa/send",
    GET_CALL_STATS: "gsa/get_call_stats",
    RAISE_COMPLAINT: "gsa/raise_complaint",
    GET_COMPLAINTS: "gsa/get_complaints",
    ASSIGN_DOCTOR: "gsa/assign_doctor",
    SEND_FEEDBACK: "gsa/send_feedback",
    GET_AVAILABLE_SLOTS: "gsa/get_available_slots",
    GET_ALL_LEADS: "gsa/get_all_leads",
    LEAD_TRANSFER_BY_COMMA: "gsa/set_comments",
    GET_PANEL_USERS: "gsa/get_panel_user",
    RESAMPLE_BOOKING: "gsa/resample_booking",
    GET_SYNC_DATA: "gsa/get_sync_data",
    GET_TUBE_DETAILS: "gsa/get_tub_details",
    GET_BOOKING_RECEIVED_PACKAGE: "gsa/get_booking_received_package",
    GET_SMS_REPORT_SEND: "gsa/get_sms_report_send",
    GET_SMS_LINK: "gsa/send_sms_link",
    GET_REPORT_DOWNLOAD: "gsa/get_report_download",
    GET_REPORT_STATUS: "gsa/get_report_status",
    GET_CENTER_INFORMATION: "gsa/get_center_information",
    GET_PAYMENT_INFORMATION: "gsa/get_payment_information",
    GET_NOTIFICATION_MESSAGE: "gsa/get_notification_message",
    GET_UNMASKED_NUMBER: "gsa/get_unmasked_number",
    GET_SAMPLE_HANDOVER_DATA: "gsa/getsample_handover_data",
    GET_SAMPLE_JOURNEY_COMMENTS: "gsa/get_sample_journey_comments",
    UPDATE_RIDER_TO_LAB_STATUS: "gsa/update_rider_to_lab_status",
    GET_ADDITIONAL_BOOKING: "gsa/get_additional_booking",
    GET_SIGNATURE: "gsa/get_signature",
    GET_REPEATED_LEADS: "gsa/get_repeted_lead",
    GET_QRCODE_DATA: "gsa/get_qrcode_data",
    GET_PACKAGE_TUBE_DETAILS: "gsa/get_package_tube_details",
    GET_RIDER_LIST: "gsa/get_rider_list",
    GET_UNREGISTERD_BOOKING: "gsa/get_unregisterd_booking",
    UPDATE_UNREGISTERD_BOOKING_STATUS: "gsa/update_unregisterd_booking_status",
    GET_UNSYNC_BOOKING: "gsa/get_unsync_booking",
    GET_BOOKING_BY_BARCODE: "gsa/get_booking_by_barcode",
    GET_SUB_CENTER_INFORMATION: "gsa/get_sub_center_information",
    GET_IMAGING_TIMESLOTS: "gsa/get_imaging_timeslots",
    GET_MULTIPLE_PACKAGES: "gsa/get_multiple_package",
    GET_DISPLAY_CITIES: "gsa/get_display_cities",
    CHECK_GEOFENCE_AREA_MAMPMYINDIA: "gsa/checking-geofence-area-mapmyindia",
    GET_MAMPMYINDIA_ACCESS_TOKEN: "gsa/get-mapmyindia-access-token",
    CHECK_GEOFENCE_AREA: "gsa/checking-geofence-area",
    GET_DOCTOR_INFO_BY_ID: "gsa/get_doctor_info",
    GET_RECEIVED_PACKAGES: "gsa/get_received_packages",
    GET_REF_DOCTOR: "gsa/get_ref_doctor",
    GET_DOCTOR_QUAL: "gsa/get_doctor_qual",
    GET_DOCTOR_SPEC: "gsa/get_doctor_spec",
    POST_REF_DOCTOR: "gsa/post_ref_doctor",
    REF_DOCTOR_RESET: "gsa/ref_doctor_reset",
    GET_BIOMARKER_SCREENING: "gsa/biomarker_screening",
    GET_BIOMARKER_ULTASOUND: "gsa/biomarker_ultasound",
    GET_TUBE_BY_BOOKING: "gsa/get_tube_by_booking",
    GET_BOOKINGS_BY_CENTRE: "gsa/get_booking_by_centre",
    POST_SAMPLE_COLLECTION: "gsa/post_sample_collection",
    BOOKING_DATA_RESET: "gsa/booking_data_reset",
    TRF_UPLOAD_FORM: "gsa/trf_upload_form",
    GET_UPLOAD_TRF: "gas/get_upload_trf",
    GET_BOOKING_OVERVIEW: "gsa/booking_overview",



};
interface GetReceivedPackages {
    type: typeof ACTIONS.GET_RECEIVED_PACKAGES;
    payload: Array<any>;
}
interface GetUploadTrf {
    type: typeof ACTIONS.GET_UPLOAD_TRF;
    payload: Array<any>;
}
interface GetBookingOverview {
    type: typeof ACTIONS.GET_BOOKING_OVERVIEW;
    payload: Array<any>;
}
interface PostUploadTrf {
    type: typeof ACTIONS.TRF_UPLOAD_FORM;
    payload: Array<any>;
}
interface BookingDataReset {
    type: typeof ACTIONS.BOOKING_DATA_RESET;
    payload: boolean;
}
interface PostSampleCollection {
    type: typeof ACTIONS.POST_SAMPLE_COLLECTION;
    payload: Array<any>;
}
interface GetBookingsByCentre {
    type: typeof ACTIONS.GET_BOOKINGS_BY_CENTRE;
    payload: boolean;
}
interface GetTubeByBooking {
    type: typeof ACTIONS.GET_TUBE_BY_BOOKING;
    payload: boolean;
}
interface RefDoctorReset {
    type: typeof ACTIONS.REF_DOCTOR_RESET;
    payload: boolean;
}
interface GetBiomarkerScreening {
    type: typeof ACTIONS.GET_BIOMARKER_SCREENING;
    payload: Object;
}
interface GetBiomarkerUltasound {
    type: typeof ACTIONS.GET_BIOMARKER_ULTASOUND;
    payload: Object;
}
interface PostRefDoctor {
    type: typeof ACTIONS.POST_REF_DOCTOR;
    payload: Array<any>;
}
interface GetDoctorSpec {
    type: typeof ACTIONS.GET_DOCTOR_SPEC;
    payload: Array<any>;
}
interface GetDoctorQual {
    type: typeof ACTIONS.GET_DOCTOR_QUAL;
    payload: Array<any>;
}
interface GetRefDoctor {
    type: typeof ACTIONS.GET_REF_DOCTOR;
    payload: Array<any>;
}
interface getDoctorInfoById {
    type: typeof ACTIONS.GET_DOCTOR_INFO_BY_ID;
    payload: object;
}
interface GetPinCode {
    type: typeof ACTIONS.GET_PIN_CODE;
    payload: Array<any>;
}
interface GetBookingByBarcode {
    type: typeof ACTIONS.GET_BOOKING_BY_BARCODE;
    payload: Array<any>;
}
interface GetUnregisterdBooking {
    type: typeof ACTIONS.GET_UNREGISTERD_BOOKING;
    payload: Object;
}
interface GetSignature {
    type: typeof ACTIONS.GET_SIGNATURE;
    payload: Array<any>;
}
interface GetPackageTubeDetails {
    type: typeof ACTIONS.GET_PACKAGE_TUBE_DETAILS;
    payload: Array<any>;
}
interface GetRiderList {
    type: typeof ACTIONS.GET_RIDER_LIST;
    payload: Array<any>;
}
interface GetRepetedLead {
    type: typeof ACTIONS.GET_REPEATED_LEADS;
    payload: Array<any>;
}
interface GetQRCodeData {
    type: typeof ACTIONS.GET_QRCODE_DATA;
    payload: Array<any>;
}
interface GetAdditionalBooking {
    type: typeof ACTIONS.GET_ADDITIONAL_BOOKING;
    payload: Array<any>;
}
interface GetSampleHandOver {
    type: typeof ACTIONS.GET_SAMPLE_HANDOVER_DATA;
    payload: Array<any>;
}
interface CheckGeoFenceArea {
    type: typeof ACTIONS.CHECK_GEOFENCE_AREA
    payload: Array<any>
}
interface GetUnmaskedNumber {
    type: typeof ACTIONS.GET_UNMASKED_NUMBER;
    payload: Array<any>;
}
interface UpdateRiderToLabStatus {
    type: typeof ACTIONS.UPDATE_RIDER_TO_LAB_STATUS;
    payload: Array<any>;
}
interface ChangePassword {
    type: typeof ACTIONS.CHANGE_PASSWORD;
    payload: Object;
}
interface UpdateUnregisterdBookingStatus {
    type: typeof ACTIONS.UPDATE_UNREGISTERD_BOOKING_STATUS;
    payload: Object;
}
interface UploadFile {
    type: typeof ACTIONS.UPLOAD_FILE;
    payload: Object;
}

interface GetCities {
    type: typeof ACTIONS.GET_CITIES;
    payload: Array<any>;
}

interface GetArea {
    type: typeof ACTIONS.GET_AREA;
    payload: Array<any>;
}

interface GetAgents {
    type: typeof ACTIONS.GET_AGENTS;
    payload: Array<any>;
}

interface GetPhlebo {
    type: typeof ACTIONS.GET_PHLEBOS;
    payload: Array<any>;
}
interface GetMultiplepackage {
    type: typeof ACTIONS.GET_MULTIPLE_PACKAGES;
    payload: Array<any>;
}

interface SetComments {
    type: typeof ACTIONS.SET_COMMENTS;
    payload: Object;
}

interface GetPositiveCallsComments {
    type: typeof ACTIONS.GET_POSTIVE_CALLS_COMMENTS;
    payload: Object;
}
interface GetSampleJourneyComments {
    type: typeof ACTIONS.GET_SAMPLE_JOURNEY_COMMENTS;
    payload: Object;
}

interface AddPositiveCallsComments {
    type: typeof ACTIONS.ADD_POSTIVE_CALLS_COMMENT;
    payload: Object;
}

interface ResampleBooking {
    type: typeof ACTIONS.RESAMPLE_BOOKING;
    payload: Object;
}
interface GetMapMyIndiaAccessToken {
    type: typeof ACTIONS.GET_MAMPMYINDIA_ACCESS_TOKEN
    payload: Array<any>
}
interface GetDisplayCities {
    type: typeof ACTIONS.GET_DISPLAY_CITIES;
    payload: Array<any>;
}

interface ClickToCall {
    type: typeof ACTIONS.CLICK_TO_CALL;
    payload: Array<any>;
}

interface GetPackages {
    type: typeof ACTIONS.GET_PACKAGES;
    payload: Array<any>;
}

interface GetPartners {
    type: typeof ACTIONS.GET_PARTNERS;
    payload: Array<any>;
}

interface GetCoupons {
    type: typeof ACTIONS.GET_COUPONS;
    payload: Array<any>;
}

interface SetLoading {
    type: typeof ACTIONS.SET_LOADING;
    payload: boolean;
}

interface CreateBooking {
    type: typeof ACTIONS.CREATE_BOOKING;
    payload: boolean;
}

interface UpdateBooking {
    type: typeof ACTIONS.UPDATE_BOOKING;
    payload: boolean;
}

interface GetBookings {
    type: typeof ACTIONS.GET_BOOKING_LIST;
    payload: boolean;
}

interface GetBookingById {
    type: typeof ACTIONS.GET_BOOKING_BY_ID;
    payload: boolean;
}

interface GetLeads {
    type: typeof ACTIONS.GET_LEADS;
    payload: boolean;
}

interface GetLeadDetails {
    type: typeof ACTIONS.GET_LEAD_DETAILS;
    payload: boolean;
}

interface GetLeadById {
    type: typeof ACTIONS.GET_LEAD_BY_ID;
    payload: boolean;
}

interface ResetLeadDetails {
    type: typeof ACTIONS.LEAD_DETAILS_RESET;
    payload: boolean;
}

interface GetPinCode {
    type: typeof ACTIONS.GET_PIN_CODE;
    payload: Array<any>;
}
interface ChangePassword {
    type: typeof ACTIONS.CHANGE_PASSWORD;
    payload: Object;
}
interface GetImagingTimeSlots {
    type: typeof ACTIONS.GET_IMAGING_TIMESLOTS;
    payload: Array<any>;
}
interface GetCities {
    type: typeof ACTIONS.GET_CITIES;
    payload: Array<any>;
}

interface GetArea {
    type: typeof ACTIONS.GET_AREA;
    payload: Array<any>;
}
interface CheckGeoFenceAreaMapMyIndia {
    type: typeof ACTIONS.CHECK_GEOFENCE_AREA_MAMPMYINDIA
    payload: Array<any>
}
interface GetPhlebo {
    type: typeof ACTIONS.GET_PHLEBOS;
    payload: Array<any>;
}

interface GetAgents {
    type: typeof ACTIONS.GET_AGENTS;
    payload: Array<any>;
}

interface SetComments {
    type: typeof ACTIONS.SET_COMMENTS;
    payload: Object;
}

interface GetPositiveCallsComments {
    type: typeof ACTIONS.GET_POSTIVE_CALLS_COMMENTS;
    payload: Object;
}

interface AddPositiveCallsComments {
    type: typeof ACTIONS.ADD_POSTIVE_CALLS_COMMENT;
    payload: Object;
}
interface ClickToCall {
    type: typeof ACTIONS.CLICK_TO_CALL;
    payload: Array<any>;
}

interface GetPackages {
    type: typeof ACTIONS.GET_PACKAGES;
    payload: Array<any>;
}

interface GetPartners {
    type: typeof ACTIONS.GET_PARTNERS;
    payload: Array<any>;
}

interface GetCoupons {
    type: typeof ACTIONS.GET_COUPONS;
    payload: Array<any>;
}

interface SetLoading {
    type: typeof ACTIONS.SET_LOADING;
    payload: boolean;
}

interface CreateBooking {
    type: typeof ACTIONS.CREATE_BOOKING;
    payload: boolean;
}


interface GetBookings {
    type: typeof ACTIONS.GET_BOOKING_LIST;
    payload: boolean;
}

interface GetBookingById {
    type: typeof ACTIONS.GET_BOOKING_BY_ID;
    payload: boolean;
}

interface GetLeads {
    type: typeof ACTIONS.GET_LEADS;
    payload: boolean;
}

interface GetLeadDetails {
    type: typeof ACTIONS.GET_LEAD_DETAILS;
    payload: boolean;
}

interface GetLeadById {
    type: typeof ACTIONS.GET_LEAD_BY_ID;
    payload: boolean;
}

interface ResetLeadDetails {
    type: typeof ACTIONS.LEAD_DETAILS_RESET;
    payload: boolean;
}
interface GetSubCenterInformation {
    type: typeof ACTIONS.GET_SUB_CENTER_INFORMATION;
    payload: Array<any>;
}
interface SearchCall {
    type: typeof ACTIONS.SEARCH_CALL;
    payload: Object;
}
interface SearchCall {
    type: typeof ACTIONS.SEARCH_CALL;
    payload: Object;
}
interface GetAgentByUserGroup {
    type: typeof ACTIONS.GET_AGENTS_BY_USERGROUP;
    payload: Object;
}

interface CreateAdditionalBooking {
    type: typeof ACTIONS.CREATE_ADDITIONAL_BOOKING;
    payload: Object;
}
interface UpdateAdditionalBooking {
    type: typeof ACTIONS.UPDATE_ADDITIONAL_BOOKING;
    payload: Object;
}
interface GetSyncData {
    type: typeof ACTIONS.GET_SYNC_DATA;
    payload: Object;
}
interface GetTubeDetails {
    type: typeof ACTIONS.GET_TUBE_DETAILS;
    payload: Array<any>;
}
interface GetBookingReceivedPackage {
    type: typeof ACTIONS.GET_BOOKING_RECEIVED_PACKAGE;
    payload: Array<any>;
}
interface GetSmsReportSent {
    type: typeof ACTIONS.GET_SMS_REPORT_SEND;
    payload: Object;
}
interface SendSmsLink {
    type: typeof ACTIONS.GET_SMS_LINK;
    payload: Object;
}
interface GetReportDownload {
    type: typeof ACTIONS.GET_REPORT_DOWNLOAD;
    payload: Object;
}
interface GetReportStatus {
    type: typeof ACTIONS.GET_REPORT_STATUS;
    payload: Array<any>;
}
interface GetCenterInfo {
    type: typeof ACTIONS.GET_CENTER_INFORMATION;
    payload: Array<any>;
}
interface GetPaymentInfro {
    type: typeof ACTIONS.GET_PAYMENT_INFORMATION;
    payload: Array<any>;
}
interface GetNotificationMessage {
    type: typeof ACTIONS.GET_NOTIFICATION_MESSAGE;
    payload: Array<any>;
}
export type PhlebognadminTypes =
    | SearchCall
    | GetPinCode
    | ChangePassword
    | GetCities
    | GetArea
    | GetAgents
    | GetPhlebo
    | GetAgentByUserGroup
    | CreateAdditionalBooking
    | UpdateAdditionalBooking
    | GetPackages
    | CreateBooking
    | UpdateBooking
    | GetPartners
    | GetCoupons
    | GetBookings
    | GetBookingById
    | SetLoading
    | GetLeadDetails
    | GetLeads
    | GetLeadById
    | ResetLeadDetails
    | ClickToCall
    | GetPositiveCallsComments
    | AddPositiveCallsComments
    | SetComments
    | UploadFile
    | GetPinCode
    | ChangePassword
    | GetCities
    | GetArea
    | GetAgents
    | GetPhlebo
    | GetPackages
    | GetPartners
    | GetCoupons
    | GetBookings
    | GetBookingById
    | SetLoading
    | GetLeadDetails
    | GetLeads
    | GetLeadById
    | ResetLeadDetails
    | ClickToCall
    | GetPositiveCallsComments
    | AddPositiveCallsComments
    | SetComments
    | SearchCall
    | ResampleBooking
    | GetSyncData
    | GetTubeDetails
    | GetBookingReceivedPackage
    | GetSmsReportSent
    | SendSmsLink
    | GetReportDownload
    | GetReportStatus
    | GetCenterInfo
    | GetPaymentInfro
    | GetNotificationMessage
    | GetUnmaskedNumber
    | GetSampleHandOver
    | GetSampleJourneyComments
    | UpdateRiderToLabStatus
    | GetAdditionalBooking
    | GetSignature
    | GetQRCodeData
    | GetRepetedLead
    | GetPackageTubeDetails
    | GetRiderList
    | GetUnregisterdBooking
    | UpdateUnregisterdBookingStatus
    | GetBookingByBarcode
    | GetSubCenterInformation
    | GetImagingTimeSlots
    | GetMultiplepackage
    | GetDisplayCities
    | CheckGeoFenceAreaMapMyIndia
    | GetMapMyIndiaAccessToken
    | CheckGeoFenceArea
    | getDoctorInfoById
    | GetReceivedPackages
    | GetRefDoctor
    | GetDoctorQual
    | GetDoctorSpec
    | PostRefDoctor
    | RefDoctorReset
    | GetBiomarkerScreening
    | GetBiomarkerUltasound
    | PostSampleCollection
    | GetBookingsByCentre
    | GetTubeByBooking
    | BookingDataReset
    | GetUploadTrf
    | PostUploadTrf
    | GetBookingOverview



